/*
 * Description:
 * ---------------------
 * The Firewall screen's Access: who reaches this box's settings and command
 * line once the firewall is on, its own network and the Weavian cloud always,
 * and the management networks an operator lists, edited here. Each edit is a
 * firewall change with every other setting sent as it is, applied and
 * confirmed by the panel's apply. Wording in firewallWords.js.
 *
 * ! file components/FirewallAccess.js
 */
import React, { useState } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import { TbBan, TbBuildingSkyscraper, TbCloud, TbDevices } from "react-icons/tb";
import * as W from "./firewallWords";

function Row({ Icon, words, chip, children, tone }) {
  return (
    <li className={`fw-access-row${tone ? ` is-${tone}` : ""}`}>
      <span className="fw-feature-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.8} /></span>
      <div className="fw-access-main">
        <div className="fw-access-head">
          <strong>{words.title}</strong>
          {chip && <span className={`fw-chip is-${chip.tone}`}>{chip.label}</span>}
        </div>
        <p>{words.text}</p>
        {children}
      </div>
    </li>
  );
}

export default function FirewallAccess({ view, settings, locked, apply }) {
  const [adding, setAdding] = useState("");
  const nets = view.management_networks || [];
  const always = { tone: view.on ? "on" : "off", label: W.ACCESS.always };
  const add = async (e) => {
    e.preventDefault();
    if (!adding.trim()) return;
    if (await apply({ ...settings, management_networks: [...nets, adding.trim()] })) setAdding("");
  };
  const remove = (net) => apply({ ...settings, management_networks: nets.filter((n) => n !== net) });
  return (
    <section className="fw-card">
      <header className="fw-card-head">
        <h3 className="fw-card-title">{W.ACCESS.title}</h3>
        <p>{W.ACCESS.means}</p>
      </header>
      {!view.on && <p className="fw-inline-note is-warn">{W.ACCESS.off}</p>}
      <ul className="fw-access">
        <Row Icon={TbDevices} words={W.ACCESS.lan} chip={always} />
        <Row Icon={TbCloud} words={view.tunnel ? W.ACCESS.cloud : W.ACCESS.cloudChannel} chip={always} />
        <Row Icon={TbBuildingSkyscraper} words={W.ACCESS.mgmt}
          chip={{ tone: nets.length && view.on ? "on" : "off", label: nets.length ? W.plural(nets.length, "network") : W.ACCESS.none }}>
          {nets.length > 0 && (
            <ul className="fw-tags">
              {nets.map((n) => (
                <li key={n}>
                  <code>{W.shown(n)}</code>
                  <button type="button" aria-label={`Remove ${W.shown(n)}`} disabled={locked} onClick={() => remove(n)}><FiX size={13} /></button>
                </li>
              ))}
            </ul>
          )}
          <form className="fw-add" onSubmit={add}>
            <input value={adding} onChange={(e) => setAdding(e.target.value)} placeholder={W.ACCESS.add}
              aria-label="Management network to add" />
            <button type="submit" className="fw-btn" disabled={locked || !adding.trim()}><FiPlus size={14} aria-hidden="true" /> Add</button>
          </form>
        </Row>
        {view.on && <Row Icon={TbBan} words={W.ACCESS.everyone} chip={{ tone: "bad", label: W.ACCESS.noAnswer }} tone="bad" />}
      </ul>
      <p className="fw-foot">{W.ACCESS.safe}</p>
      <details className="fw-how">
        <summary>{W.ACCESS.ports}</summary>
        <p>{W.accessPorts(view)}</p>
      </details>
    </section>
  );
}
